import {
  REJECT_PRODUCT_FAILURE, REJECT_PRODUCT_REQUEST, DELETE_PRODUCT_FAILURE, DELETE_PRODUCT_REQUEST, APPROVED_PRODUCT_FAILURE, APPROVED_PRODUCT_REQUEST, GET_PRODUCTS_FAILURE, GET_PRODUCTS_REQUEST, GET_PRODUCTS_SUCCESS, GET_ALL_PRODUCTS_FAILURE, GET_ALL_PRODUCTS_REQUEST, GET_ALL_PRODUCTS_SUCCESS, CREATE_PRODUCT_REQUEST, CREATE_PRODUCT_FAILURE, UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT_SUCCESS,
} from "./ActionType";


const initialState = {
  loading: false,
  products: [],
  adminProducts: [],
  error: "",
}

const adminProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCTS_REQUEST:
    case GET_ALL_PRODUCTS_REQUEST:
      return { ...state, loading: true };

    case GET_PRODUCTS_SUCCESS:
      return { ...state, loading: false, products: action.payload, error: "" };
    case GET_ALL_PRODUCTS_SUCCESS:
      return { ...state, loading: false, adminProducts: action.payload, error: "" };

    case GET_PRODUCTS_FAILURE:
      return { ...state, loading: false, products: [], error: action.payload };
    case GET_ALL_PRODUCTS_FAILURE:
      return { ...state, loading: false, adminProducts: [], error: action.payload };

    case APPROVED_PRODUCT_REQUEST:
    case REJECT_PRODUCT_REQUEST:
    case CREATE_PRODUCT_REQUEST:
    case UPDATE_PRODUCT_REQUEST:
      return { ...state, loading: true, error: "" };

    case APPROVED_PRODUCT_FAILURE:
    case REJECT_PRODUCT_FAILURE:
    case CREATE_PRODUCT_FAILURE:
    case UPDATE_PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_PRODUCT_REQUEST:
      return { ...state, loading: true, error: "" };

    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        adminProducts: state.adminProducts?.response?.filter(prd => prd.id !== action.payload)  // Remove deleted category
      };

    case DELETE_PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
export default adminProductReducer